import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import { PublicClientApplication } from "@azure/msal-browser";

// const msalConfig = {
//   auth: {
//     clientId: process.env.REACT_APP_AZURE_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
//     authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_AZURE_TENANT_ID,
//     redirectUri: window.location.origin, // Specific callback route
//     postLogoutRedirectUri: "/login",
//   },
//   cache: {
//     cacheLocation: "localStorage", // This configures where your cache will be stored
//     storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
//   },
//   system: {
//     loggerOptions: {
//       loggerCallback: (level, message, containsPii) => {
//         if (containsPii) {
//           return;
//         }
//         switch (level) {
//           case "Error":
//             console.error("MSAL Error:", message);
//             return;
//           case "Info":
//             console.info("MSAL Info:", message);
//             return;
//           case "Verbose":
//             console.debug("MSAL Verbose:", message);
//             return;
//           case "Warning":
//             console.warn("MSAL Warning:", message);
//             return;
//         }
//       },
//     },
//   },
// };
// const msalInstance = new PublicClientApplication(msalConfig);

// // Initialize MSAL instance
// msalInstance
//   .initialize()
//   .then(() => {
//     // Handle redirect promise on app startup
//     msalInstance
//       .handleRedirectPromise()
//       .then((tokenResponse) => {
//         if (tokenResponse) {
//           console.log("Token acquired on startup:", tokenResponse);
//           msalInstance.setActiveAccount(tokenResponse.account);
//         }
//       })
//       .catch((error) => {
//         console.error("Error handling redirect on startup:", error);
//       });

//     ReactDOM.render(
//       <React.StrictMode>
//         <App instance={msalInstance} />
//       </React.StrictMode>,
//       document.getElementById("root")
//     );
//   })
//   .catch((error) => {
//     console.error("MSAL initialization failed:", error);
//   });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

